import { FC } from "react";

import { SectionScoreCard } from "../SectionScoreCard";

import { StudentPerformanceDashboard } from "./StudentPerformanceDashboard";

type StudentAssessmentViewProps = {
  sectionScoreEnabled: boolean;
  userId: string;
};

export const StudentAssessmentView: FC<StudentAssessmentViewProps> = ({
  sectionScoreEnabled,
  userId,
}) => {
  const sectionScores = sectionScoreEnabled ? <SectionScoreCard userId={userId} /> : null;

  return (
    <>
      {sectionScores}
      <StudentPerformanceDashboard userId={userId} />
    </>
  );
};
